import * as actionTypes from './actionTypes';

const initialState = {
  activeDashboardId: null,
  ids: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.SET_ACTIVE_TAG_ID:
      return {
        ...state,
        activeDashboardId: action.id,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.tag.id],
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== action.id),
        activeDashboardId: action.id === state.activeTagId ? null : state.activeTagId,
      };
    default:
      return state;
  }
};
